import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets scroll to the top on route (pathname) change — React Router otherwise
 * preserves the previous page's scroll position. In-page anchor navigation
 * (a `#hash` in the URL) is left untouched so jump links still work.
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
